export default "__VITE_ASSET__CLhap7IN__"